import {lazy} from 'react';

// ./company
const CompanyDetail = lazy(() => import('./company/CompanyDetail'));
const CompanyMetrics = lazy(() => import('./company/CompanyMetrics'));
const CompanyEdit = lazy(() => import('./company/CompanyEdit'));
const InactiveCompany = lazy(() => import('./company/InactiveCompany'));

// ./doctor
const DoctorList = lazy(() => import('./doctor/DoctorList'));
const DoctorRecoverPassword = lazy(() => import('./doctor/DoctorRecoverPassword'));
const DoctorCreate = lazy(() => import('./doctor/DoctorCreate'));
const DoctorEdit = lazy(() => import('./doctor/DoctorEdit'));
const DoctorDelete = lazy(() => import('./doctor/DoctorDelete'));

// ./event
const EventCreate = lazy(() => import('./event/EventCreate/EventCreate'));
const EventEdit = lazy(() => import('./event/EventEdit/EventEdit'));
const EventsList = lazy(() => import('./event/EventsList'));

// ./patient
const PatientList = lazy(() => import('./patient/PatientList/PatientList'));
const PatientDetail = lazy(() => import('./patient/PatientDetail'));
const PatientEdit = lazy(() => import('./patient/PatientEdit'));
const PatientCreate = lazy(() => import('./patient/PatientCreate'));
const PatientDelete = lazy(() => import('./patient/PatientDelete'));
const PatientRecoverPassword = lazy(() => import('./patient/PatientRecoverPassword'));

// ./self-performed-test-alerts
const SelfPerformedTestAlertList = lazy(() =>
  import('./self-performed-test-alerts/SelfPerformedTestAlertList')
);

// ./test
const TestRequest = lazy(() => import('./test/TestRequest'));
const TestResult = lazy(() => import('./test/TestResult'));

// ./user
const UserHome = lazy(() => import('./user/UserHome'));


export default {
  CompanyDetail,
  CompanyEdit,
  CompanyMetrics,
  InactiveCompany,
  TestResult,
  TestRequest,
  DoctorCreate,
  DoctorEdit,
  DoctorDelete,
  DoctorList,
  DoctorRecoverPassword,
  SelfPerformedTestAlertList,
  EventCreate,
  EventsList,
  EventEdit,
  PatientList,
  PatientDetail,
  PatientEdit,
  PatientCreate,
  PatientDelete,
  PatientRecoverPassword,
  UserHome
};
